import React from "react";
import {
  ALPHA_NUMERIC_REGEX,
  PrimaryFormTextField,
  RESTRICT_LEADING_SPACE,
} from "react-common-ui-library";
import {
  ACCESS_CODE_INVALID_ERROR_MESSAGE,
  ACCESS_CODE_LABEL,
  ACCESS_CODE_MAXLENGTH,
  ACCESS_CODE_NAME,
  ACCESS_CODE_REQUIRED_ERROR_MESSAGE,
} from "../../../Constants/ConfirmSiteAccessConstants";

const AccessCode = () => {
  return (
    <PrimaryFormTextField
      formProps={{
        name: ACCESS_CODE_NAME,
        rules: {
          required: ACCESS_CODE_REQUIRED_ERROR_MESSAGE,
          minLength: {
            value: ACCESS_CODE_MAXLENGTH,
            message: ACCESS_CODE_INVALID_ERROR_MESSAGE,
          },
          maxLength: {
            value: ACCESS_CODE_MAXLENGTH,
            message: ACCESS_CODE_INVALID_ERROR_MESSAGE,
          },
          pattern: {
            value: ALPHA_NUMERIC_REGEX,
            message: ACCESS_CODE_INVALID_ERROR_MESSAGE,
          },
        },
      }}
      labelProps={{ labelText: ACCESS_CODE_LABEL, required: true }}
      fieldProps={{
        restrictionPattern: RESTRICT_LEADING_SPACE,
      }}
    />
  );
};

export default AccessCode;
